export default "__VITE_ASSET__DI5B0XeU__"